
//积分商城-优惠券
import { get, post, postJson, put, deleteApi } from '../axios2'

const RESOURCE_BASE_PATH = '/sellerCouponWrite';


//创建优惠券(京券和东券）
export const createSellerCouponWrite = p => postJson(`${RESOURCE_BASE_PATH}`, p);

//查询优惠券详情(京券和东券）
export const querydetail = couponId => get(`${RESOURCE_BASE_PATH}/detail/${couponId}`);

//添加外部优惠券(京东自营)
export const addExternal = p => postJson(`${RESOURCE_BASE_PATH}/external`, p);

//获取商家外部优惠券列表  
export const querySellerCouponExternalList = p => postJson(`${RESOURCE_BASE_PATH}/external/list`, p);

//获取商家内部优惠券列表  
export const querySellerCouponWriteList = p => postJson(`${RESOURCE_BASE_PATH}/list`, p);
 
//关闭优惠券(京券和东券)
export const closeSellerCouponWrite = couponId => put(`${RESOURCE_BASE_PATH}/${couponId}`);

//获取外部优惠券(通过putKey)
export const byPutKey = putKey => get(`${RESOURCE_BASE_PATH}/external/get/byPutKey/${putKey}`);

